<template>
  <div class="mt-2 cancelar-diario">
    <div>
      <v-btn icon :to="{ name: 'diario-escolar', params: { paginaAtualTurmas }}">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <div class="mt-2">
      <v-alert v-if="msgError" type="error" value="true" style="color: white;">
        <div>{{ msgError }}</div>
      </v-alert>
    </div>

    <Select
      class="mt-4 cancelar-diario-periodo"
      label="Período Avaliativo Autorizado"
      v-model="periodoSelecionado"
      :options="periodosAvaliativos"
      :v="$v.periodoSelecionado"
    />

    <div class="mb-2">
      <v-btn
        type="button"
        color="teal"
        class="float-right"
        style="padding: 25px 15px;"
        @click="cancelarDiario"
      >
       <span class="white--text font-weight-regular ms-2">Confirmar cancelamento</span>
      </v-btn>
    </div>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text" icon @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");

export default {
  name: "diario-escolar-cancelar-diario",
  props: {
    paginaAtualTurmas: [String, Number],
    periodos: Array,
    ano: [String, Number],
    cdtipesc: [String, Number],
    cdescola: [String, Number],
    cdinstruc: [String, Number],
    cdserie: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    cdpessoal: [String, Number],
    cdmatric: [String, Number],
    tipoAvaliacao: [String]
  },
  data() {
    return {
      submitText: "",
      snackbar: false,
      loading: false,
      periodoSelecionado: "",
      periodosAvaliativos: [],
      msgError: "",
    };
  },
  validations: {
    periodoSelecionado: { required, integer }
  },
  async beforeRouteEnter(to, from, next) {
    if (typeof to.params.periodos === "undefined") {
      return next("/diario-escolar");
    }
    try {
      next((vm) => {});
    } catch (e) {
      return next("/diario-escolar");
    }
  },
  mounted() {
    this.periodos.forEach(p => {
      this.periodosAvaliativos.push({value: p.cdpravadi, text: p.dspravadi})
    });
    this.periodosAvaliativos.unshift({value: '', text: ''})
    this.$Progress.finish();
  },
  methods: {
    async cancelarDiario() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      const confirmar = await this.$sgal({
        title: 'Atenção!',
        text: 'Esta ação irá EXCLUIR permanentemente todos os dados de aulas, frequências, conceitos e notas neste período avaliativo, específico deste professor.<br><br><strong>Tem certeza que deseja excluir o seu diário neste período avaliativo?</strong>',
        // text: 'Esta ação irá EXCLUIR permanentemente todos os dados de aulas, frequências, conceitos, notas e pareceres descritivos neste período avaliativo, específico deste professor.<br><br><strong>Tem certeza que deseja excluir o seu diário neste período avaliativo?</strong>',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        let params = {
          aaletivo: parseInt(this.ano),
          cdtipesc: parseInt(this.cdtipesc),
          cdescola: parseInt(this.cdescola),
          cdinstruc: parseInt(this.cdinstruc),
          cdserie: parseInt(this.cdserie),
          cdturma: this.cdturma,
          cddiscipl: parseInt(this.disciplina),
          cdpessoal: parseInt(this.cdpessoal),
          cdmatric: parseInt(this.cdmatric),
          cdpravadi: parseInt(this.periodoSelecionado),
          tipoAvaliacao: this.tipoAvaliacao
        }

        const { data } = await DiarioEscolarRepository.cancelarDiario(params);
        this.submitText = data.message;
        this.snackbar = true;
      } catch(error) {
      }
    },
  },
};
</script>

<style lang="scss" scope>
@media only screen and (max-width: 500px) {
  .v-btn { width: 100%; margin-top: 20px; }
}

.cancelar-diario {
  .cancelar-diario-periodo { width: 300px; }
}

@media only screen and (max-width: 500px) {
  .cancelar-diario-periodo { width: 100% !important;}
}
</style>
